var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19.5px",
    height: "19.5px",
    viewBox: "0 0 19.5 19.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:cog-8-tooth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NCOB-Settings-Quick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC-OB-General-On",
    transform: "translate(-67.249, -225.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:cog-8-tooth",
    transform: "translate(65, 223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(2.999, 3)",
    stroke: "#8E06BF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.344,0.94 C7.434,0.398 7.904,0 8.454,0 L9.547,0 C10.097,0 10.567,0.398 10.657,0.94 L10.806,1.834 C10.876,2.258 11.19,2.598 11.586,2.764 C11.984,2.928 12.441,2.906 12.791,2.656 L13.528,2.129 C13.9756398,1.80901299 14.5890534,1.85977826 14.978,2.249 L15.751,3.023 C16.141,3.412 16.191,4.025 15.871,4.473 L15.344,5.21 C15.094,5.56 15.072,6.016 15.237,6.414 C15.402,6.811 15.742,7.124 16.167,7.194 L17.06,7.344 C17.603,7.434 18,7.904 18,8.453 L18,9.547 C18,10.097 17.603,10.567 17.06,10.657 L16.167,10.806 C15.742,10.876 15.402,11.189 15.237,11.586 C15.072,11.984 15.094,12.44 15.344,12.79 L15.871,13.528 C16.191,13.975 16.14,14.588 15.751,14.978 L14.977,15.751 C14.5881989,16.1396688 13.9754416,16.1904147 13.528,15.871 L12.79,15.344 C12.44,15.094 11.984,15.072 11.587,15.237 C11.19,15.402 10.877,15.742 10.806,16.166 L10.657,17.06 C10.567,17.602 10.097,18 9.547,18 L8.453,18 C7.903,18 7.434,17.602 7.343,17.06 L7.195,16.166 C7.124,15.742 6.811,15.402 6.414,15.236 C6.016,15.072 5.56,15.094 5.21,15.344 L4.472,15.871 C4.025,16.191 3.412,16.14 3.022,15.751 L2.249,14.977 C1.85977826,14.5880534 1.80901299,13.9746398 2.129,13.527 L2.656,12.79 C2.906,12.44 2.929,11.984 2.764,11.586 C2.599,11.189 2.259,10.876 1.834,10.806 L0.94,10.656 C0.398,10.566 0,10.096 0,9.547 L0,8.453 C0,7.903 0.398,7.433 0.94,7.343 L1.834,7.194 C2.258,7.124 2.599,6.811 2.764,6.414 C2.929,6.016 2.907,5.56 2.657,5.21 L2.13,4.472 C1.81001299,4.02436023 1.86077826,3.41094663 2.25,3.022 L3.023,2.249 C3.41194663,1.85977826 4.02536023,1.80901299 4.473,2.129 L5.21,2.656 C5.56,2.906 6.017,2.928 6.414,2.763 C6.811,2.598 7.124,2.258 7.194,1.834 L7.344,0.94 L7.344,0.94 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001,9 C12.001,10.6568542 10.6578542,12 9.001,12 C7.34414575,12 6.001,10.6568542 6.001,9 C6.001,7.34314575 7.34414575,6 9.001,6 C10.6578542,6 12.001,7.34314575 12.001,9 L12.001,9 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralPurple);
export default __webpack_public_path__ + "static/media/General-purple.81f8708cb05b183918d8c89b789ac5f8.svg";
export { ForwardRef as ReactComponent };